module.exports = __webpack_public_path__ + "img/_Generic3.80d25d95.jpg";